import styled from "@emotion/styled"
import "swiper/css"
import "swiper/css/effect-coverflow"
import "swiper/css/effect-fade"
import "swiper/css/pagination"
import { Apartment } from "utils"
import ApartmentGallery from "../../ApartmentsForRent/ApartmentGallery"
import ApartmentPlan from "../../ApartmentsForRent/ApartmentPlan"
import ApartmentDocs from "./ApartmentDocs"
import ApartmentFeatures from "./ApartmentMarketingForRent/ApartmentFeatures"
import ApartmentPlanFRM from "./ApartmentMarketingForRent/ApartmentPlanFMR"
import BuildingFeatures from "./ApartmentMarketingForRent/BuildingFeatures"
import { NewTabNameType, TabNameType } from "./ApartmentMarketingForRent/DrawerInner"
import ProjectLocation from "./ApartmentMarketingForRent/ProjectLocation"
import ApartmentSpec from "./ApartmentSpec"

const StyledPlan = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`
type DetailsProps = {
  apartment: Apartment
  type: TabNameType | NewTabNameType
  projectPage?: boolean
  imageGallery?: {
    apartmentThumbnail?: string
    apartmentGallery?: string[]
    numberOfRooms?: number
  }
  forDrawer?: boolean
  buildingCharacteristicsText?: string
}

function AccordionInnerDetails({
  apartment,
  type,
  projectPage,
  imageGallery,
  forDrawer,
  buildingCharacteristicsText,
}: DetailsProps) {
  if (type === "plan") {
    return (
      <StyledPlan>
        {!forDrawer && <ApartmentGallery apartment={apartment} imageGallery={imageGallery} />}
        <ApartmentSpec apartment={apartment} projectPage={projectPage} />
      </StyledPlan>
    )
  }
  if (type === "specs") {
    return <ApartmentPlan apartment={apartment} projectPage={projectPage} />
  }
  if (type === "docs") {
    return <ApartmentDocs apartment={apartment} />
  }
  if (type === "gallery") {
    return <ApartmentGallery apartment={apartment} />
  }
  if (type === "rentplan") {
    return <ApartmentPlan apartment={apartment} />
  }

  // for drawer
  if (type === "buildingFeatures") {
    return (
      <BuildingFeatures
        apartment={apartment}
        buildingCharacteristicsText={buildingCharacteristicsText}
      />
    )
  }
  if (type === "apartmentFeatures") {
    return <ApartmentFeatures apartment={apartment} />
  }
  if (type === "projectLocation") {
    return <ProjectLocation apartment={apartment} />
  }
  if (type === "apartmentPlan") {
    return <ApartmentPlanFRM apartment={apartment} />
  }
  if (type === "documents") {
    return <ApartmentDocs apartment={apartment} newStyle />
  }

  return null
}

export default AccordionInnerDetails
